var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRarrowpLarge = function SvgRarrowpLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "884.313 212.192 9.943 15.628"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M892.52 212.192c.478 0 .718.236 1.197.472.72.707.72 1.65 0 2.359l-5.27 5.19 4.791 4.717c.718.708.718 1.651 0 2.359-.719.708-1.677.708-2.396 0l-5.99-5.897c-.719-.708-.719-1.652 0-2.36l6.47-6.368c.24-.236.718-.472 1.197-.472z",
    fill: "#F2C2C8"
  })));
};
export default SvgRarrowpLarge;